import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../../API/axiosNeatex';
import type { FaTransferModels } from './FaTransferModels';
import type { APIResponse } from '../../../Shared/shared';

export const addFaTransfer = createAsyncThunk(
  'FaTransfer/addFaTransfer',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>(
        'FATransaction/AddFaFaTransferTransactions',
        item
      );
      if (data?.succeeded) {
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateFaTransfer = createAsyncThunk(
  'FaTransfer/updateFaTransfer',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>(
        'FATransaction/UpdateFaFaTransferTransactions',
        item
      );
      if (data?.succeeded) {
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getFaTransferList = createAsyncThunk(
  'FaTransfer/getFaTransferList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<FaTransferModels[]>>(
        'FATransaction/GetTransferList'
      );
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getFaTransferById = createAsyncThunk(
  'FaTransfer/getFaTransferById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<FaTransferModels>>(
        `FATransaction/GetFaTransferById?Id=${id}`
      );
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// export const getDepreciationByAssetId = createAsyncThunk(
//   'Depreciation/getDepreciationByAssetId',
//   async (AssetId: string, { rejectWithValue }) => {
//     try {
//       const { data } = await ntxAPI.get<APIResponse<DepreciationModels>>(`FA/GetDepreciationByAssetId?AssetId=${AssetId}`);
//       if (data?.succeeded) {
//         return data?.data;
//       } else {
//         return rejectWithValue(data.message);
//       }
//     } catch (error: any) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

const initialState: {
  FaTransferList: FaTransferModels[];
  FaTransferById: FaTransferModels;
  // FaTransferByAssetId: FaTransferModels;
  loading: boolean;
  error: any | null;
} = {
  FaTransferList: [],
  FaTransferById: {} as FaTransferModels,
  // FaTransferByAssetId: {} as FaTransferModels,
  loading: false,
  error: null
};

const FaTransferSlice = createSlice({
  name: 'FaTransfer',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getFaTransferList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(
        getFaTransferList.fulfilled,
        (state, action: PayloadAction<FaTransferModels[]>) => {
          state.loading = false;
          state.FaTransferList = action.payload;
        }
      )
      .addCase(getFaTransferList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      ////////////////////////////////////////////////////////////////
      .addCase(getFaTransferById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getFaTransferById.fulfilled, (state, action: PayloadAction<FaTransferModels>) => {
        state.loading = false;
        state.FaTransferById = action.payload;
      })
      .addCase(getFaTransferById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });

    // .addCase(getDepreciationByAssetId.pending, (state, action) => {
    //   state.loading = true;
    // })
    // .addCase(getDepreciationByAssetId.fulfilled, (state, action: PayloadAction<DepreciationModels>) => {
    //   state.loading = false;
    //   state.DepreciationByAssetId = action.payload;
    // })
    // .addCase(getDepreciationByAssetId.rejected, (state, action: PayloadAction<any>) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // })
  }
});

export default FaTransferSlice.reducer;
